import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Habit } from './habit.model';

@Injectable({
  providedIn: 'root',
})
export class HabitService {
  today = '';

  constructor(public afs: AngularFirestore) {}

  saveHabit(habit: any, date: string): Observable<any> {
    const habitDoc = this.afs
      .collection(`${environment.custom.firebaseRootDoc}`)
      .doc(`${date}`);
    return from(habitDoc.set(habit));
  }

  getCurrentHabitsDay(today: string): Observable<any> {
    return from(
      this.afs.doc(`${environment.custom.firebaseRootDoc}/${today}`).get()
    ).pipe(map((doc) => doc.data()));
  }

  watchCurrentHabitsDay(today: string): Observable<any> {
    return this.afs
      .doc(`${environment.custom.firebaseRootDoc}/${today}`)
      .valueChanges();
  }

  deleteHabit(habit: Habit, date: string): Observable<any> {
    const habitDoc = this.afs.doc(
      `${environment.custom.firebaseRootDoc}/${date}/${habit.id}`
    );
    return from(habitDoc.delete());
  }

  updateHabit(habit: Partial<Habit>, date: string): Observable<any> {
    const habitDoc = this.afs.doc(
      `${environment.custom.firebaseRootDoc}/${date}/`
    );
    return from(
      habitDoc.update({
        [habit.id as any]: habit,
      })
    );
  }

  setupToday(today: string): void {
    this.today = today;
  }
}
